<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("cookie.menu.content") }} </template>
        <template #sidebarMain>
            <CardToggle :title="$t('cookie.content.content')">
                <div class="space-y-5">
                    <FormInput
                        id="cookieTitle"
                        :title="$t('cookie.content.title')"
                        v-model="cookie.title"
                    />
                    <FormTextArea
                        id="cookieDesc"
                        :title="$t('cookie.content.main_text')"
                        v-model="cookie.desc"
                    />
                    <FormInput
                        id="cookieAcceptText"
                        :title="$t('cookie.content.accept_label')"
                        v-model="cookie.acceptText"
                    />
                    <FormInput
                        id="cookieCancelText"
                        :title="$t('cookie.content.adjust_label')"
                        v-model="cookie.cancelText"
                        :help="$t('cookie.content.adjust_info')"
                    />

                    <FormToggleSm
                        :title="$t('cookie.content.more_link')"
                        v-model="cookie.policyLink"
                    />
                    <template v-if="cookie.policyLink">
                        <FormInput
                            id="cookiePolicyText"
                            :title="$t('cookie.content.more_text')"
                            v-model="cookie.policyText"
                        />
                        <FormInput
                            :title="$t('cookie.content.more_url')"
                            v-model="cookie.policyUrl"
                        />
                    </template>
                </div>
            </CardToggle>
            <CardToggle :title="$t('cookie.content.settings')">
                <div class="space-y-5">
                    <FormToggleSm
                        :title="$t('cookie.content.show_adjust')"
                        v-model="cookie.adjustShow"
                        :help="$t('cookie.content.show_adjust_info')"
                    />
                    <FormInput
                        id="cookieAdjustTitle"
                        :title="$t('cookie.content.adjust_title')"
                        v-model="cookie.adjustTitle"
                    />
                </div>
            </CardToggle>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { mapState, mapActions } from "vuex";
import { CardToggle } from "@easy/ui/cards";
import { FormInput, FormTextArea, FormToggleSm } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    name: "SidebarData",
    components: {
        PageSidebar,
        CardToggle,
        FormInput,
        FormTextArea,
        FormToggleSm,
        cSaveButton,
    },
    computed: {
        ...mapState("cookie", ["cookie", "hasChanges"]),
    },
    setup() {
        useFocusOnQueryField();
    },
    methods: {
        ...mapActions("cookie", ["saveSnapshot"]),
    },
};
</script>
